import React from "react";
import PropTypes from 'prop-types';

export default class OtherBenefits extends React.PureComponent
{
    static propTypes = {
        language: PropTypes.string.isRequired,
        content: PropTypes.string
    };

    render() {
        if (!this.props.content) {
            return null;
        }
        return (
            <div className="other-benifit details-section margin-bottom-30">
                <h4>
                    <i className={"padding-right-15 padding-top-15 padding-bottom-15 far fa-comments"}/>
                    {window.Translator.getSlug('interviewInfo', this.props.language)}
                </h4>
                <div dangerouslySetInnerHTML={{__html: this.props.content}}/>
            </div>
        );
    }
}